import React,{useState} from "react";
import logo from "../Assets/logo.png";
import {Link, useParams} from 'react-router-dom'
import SidebarComponent from "./SidebarComponent";
import 'primeicons/primeicons.css';


const Navbar = ({active}) => {

  console.log(active)

  const [sidebar,setSidebar] = useState(false);

  const handleIconClick=()=>{
    setSidebar(!sidebar)
  }

  
  
  return (
    <div className="flex justify-between bg-black">
      <div className="w-auto">
        <img src={logo} alt="" className="h-full w-[10rem] py-2" />
      </div>
      
        <ul className={`flex gap-4 items-center p-4 navbar_items`}>
        <li className={`text-white p-2 hover:decoration-solid  ${active == undefined && 'text-yellow-500 underline'}`}>
            <Link to="/" className=' hover:underline hover:text-yellow-500'>HOME</Link>
          </li>
          <li className={`text-white p-2 hover:decoration-solid  ${active == 'Sports' && 'text-yellow-500 underline'}`}>
            <Link to="/Category/Sports" className=' hover:underline hover:text-yellow-500'>SPORTIFS</Link>
          </li>
          <li  className={`text-white p-2  ${active == 'Funny' && 'text-yellow-500 underline'}`}>
            <Link to="/Category/Funny" className=' hover:underline hover:text-yellow-500' >FUNNY</Link>
          </li>
          <li  className={`text-white p-2 ${active == 'Action' && 'text-yellow-500 underline'}`}>
            <Link to="/Category/Action" className=' hover:underline hover:text-yellow-500'>D'ACTION</Link>
          </li>
          <li  className={`text-white p-2  ${active == 'Adventure' && 'text-yellow-500 underline'}`}>
            <Link to="/Category/Adventure" className=' hover:underline hover:text-yellow-500'>D'AVENTURE</Link>
          </li>
          <li className={`text-white p-2  ${active == 'Racing' && 'text-yellow-500 underline'}`}>
            <Link to="/Category/Racing" className=' hover:underline hover:text-yellow-500'>RACING</Link>
          </li>
          <li className={`text-white p-2 hover:decoration-solid hover:underline hover:text-yellow-500 ${active == 'Kids' && 'text-yellow-500 underline'}`}>
            <Link to="/Category/Kids" className=' hover:underline hover:text-yellow-500'>KIDS</Link>
          </li>
          <li className={`text-white p-2  ${active == 'Arcade' && 'text-yellow-500 underline'}`}>
            <Link to="/Category/Arcade" className=' hover:underline hover:text-yellow-500'>ARCADE</Link>
          </li>
          <li className={`text-white p-2  ${active == 'Puzzle' && 'text-yellow-500 underline'}`}>
            <Link to="/Category/Puzzle" className=' hover:underline hover:text-yellow-500'>PUZZLE</Link>
          </li>
        </ul>

        <div className="flex justify-center items-center p-4 menu_icon">
          <i className="pi pi-bars" style={{cursor:'pointer'}} onClick={handleIconClick}> </i>
        </div>

        <SidebarComponent visible={sidebar} handle={handleIconClick} active={active}/>
      
    </div>
  );
};

export default Navbar;
